import Service from "./Service";
const baseurl = '/api/historia';
import makeParams from "../utils/functions/makeParams";

export default {
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    showByLast(id) {
        return Service.get(`${baseurl}/show-by-last/${id}`);
    },
    showByIdUser(id) {
        return Service.get(`${baseurl}/show-by-idUser/${id}`);
    },
    updateCheckpoint(id, checkpoint) {
        return Service.put(`${baseurl}/update/checkpoint`, { id: id, checkpoint: checkpoint });
    },
    showUnfinished(id_usuario) {
        return Service.get(`${baseurl}/show-unfinished/${id_usuario}`);
    },
    print(id) {
        return `${process.env.VUE_APP_BASE_PATH}${baseurl}/print/${id}`
    },
    resumen(id) {
        return `${process.env.VUE_APP_BASE_PATH}${baseurl}/resumen/${id}`
    },
    resumenHc(id) {
        return Service.get(`${baseurl}/resumen-hc/${id}`);
    },
    formula(id) {
        return `${process.env.VUE_APP_BASE_PATH}${baseurl}/formula/${id}`
    },
    orden(id) {
        return `${process.env.VUE_APP_BASE_PATH}${baseurl}/orden/${id}`
    },
    close(data) {
        return Service.post(`${baseurl}/close`, data);
    },
    cerrarHistoria(data) {
        return Service.post(`${baseurl}/cerrar`, data);
    },
    async showByIdPaciente(search = '',pagination = {},id) {
        /* let url = `${baseurl}/show-by-idPaciente/${id}?`;

        url += search !== '' ? `s=${search}` : '';

        url += (!isEmpty(pagination))
            ? `&paginate=true&per_page=${pagination.per_page}&page=${pagination.page}`
            : '';

        return Service.get(url); */
        const hasAditionalParams = !!pagination['params'];

        let aditionalParams = {};

        if(hasAditionalParams){
            for(const param in pagination['params']){
                if(
                    pagination['params'][param] !== ''
                    && pagination['params'][param] !== undefined
                    && pagination['params'][param] !== null
                ){
                    aditionalParams[param] = pagination['params'][param]
                }
            }
        }

        const params = {
            ...(search !== '' ? {s:search} : {}),
            ...(pagination['per_page'] ? {per_page : pagination['per_page']} : {}),
            ...(pagination['page'] ? {page : pagination['page']} : {}),
            ...(hasAditionalParams ? {...aditionalParams} : {}),
        };

        return Service.get(`${baseurl}/show-by-idPaciente/${id}?`, {
            params : {
                ...params
            }
        });
    },
    async showByHC(search = '', pagination = {}) {
       
       
        const hasAditionalParams = !!pagination['params'];

        let aditionalParams = {};

        if(hasAditionalParams){
            for(const param in pagination['params']){
                if(
                    pagination['params'][param] !== ''
                    && pagination['params'][param] !== undefined
                    && pagination['params'][param] !== null
                ){
                    aditionalParams[param] = pagination['params'][param]
                }
            }
        }

        const params = {
            ...(search !== '' ? {s:search} : {}),
            ...(pagination['per_page'] ? {per_page : pagination['per_page']} : {}),
            ...(pagination['page'] ? {page : pagination['page']} : {}),
            ...(hasAditionalParams ? {...aditionalParams} : {}),
        };

        return Service.get(`${baseurl}/showByHC`, {
            params : {
                ...params
            }
        });
    },
    cambiarEstado(id) {
        return Service.put(`${baseurl}/cambiarEstado/${id}`);
    },
    reportByHCExcel(params = {}) {
        const paramsArr = [];
        for (const param in makeParams(params)) paramsArr.push(`${param}=${params[param]}`);
        window.open(`${baseurl}/reporte-historias-excel?${paramsArr.join('&')}`);
    },
    openHc(obj) {
        return Service.put(`${baseurl}/open-hc`, obj);
    },
    changeEps(data) {
        return Service.put(`${baseurl}/change-eps`, data);
    },
    anularHc(obj) {
        return Service.put(`${baseurl}/anular-hc`, obj);
    },
    cambiarFecha(data) {
        return Service.put(`${baseurl}/cambiar-fecha`, data);
    },
}
